<template>
  <transition name="scale-up-center">
    <div id="CourseOnline">
      <div class="msgs-and-members-container">
        <VuiScroll class="members-container" :bottomLoad="bottomLoad">
          <div class="member-item" v-for="v in members" :key="v.account" v-if="v.nick && !v.nick.startsWith('匿名_')">
          <img :src="v.avatar || `/img/avatar-male.svg`">
          <p class="name">
            <span>{{ v.nick }}</span>
            <span v-if="v.role > 0"> · <span class="role">{{ v.role === 2 ? '老师' : '助教' }}</span></span>
          </p>
          <p class="time" v-if="!isManager">{{ v.enterTimeString }}</p>
          <p class="time" v-if="isManager&&v.gaged" @click="cancelForbidden(v)">解除禁言</p>
          <p class="time" v-if="isManager&&!v.gaged" @click="forbiddenUser(v)">禁言</p>
        </div>
        </VuiScroll>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'CourseOnline',
  props: {
    members: Array,
    bottomLoad: Function,
    onlineMemberNum: Number,
    isManager: Boolean,
  },
  methods: {
    forbiddenUser (v) {
      this.$emit('forbiddenUser', v)
    },
    cancelForbidden (v) {
      this.$emit('cancelForbidden', v)
    },
  },
}
</script>

<style lang="scss">
$tabs-height: 0px;

#CourseOnline {
  background-color: #f0f0f0;
  overflow: hidden;
  position: relative;
  height: 100%;

  .msgs-and-members-container {
    @include pos(absolute, $tabs-height, 0, 0, 0);
  }

  .members-container {
    @include wh(100%, 100%);
    overflow-x: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }
  }

  .members-container {
    padding: 10px;
    padding-top: 64px;

    .member-item {
      @include wh(100%, 40px);
      padding: 5px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }

    img {
      @include wh(30px, 30px);
      border-radius: 4px;
    }

    .name {
      @include font(14px, initial, #444);
      margin-left: 10px;
      flex-grow: 1;
      flex-shrink: 1;
    }

    .role {
      color: #ed6c00;
    }

    .time {
      @include font(12px, initial, #868688);
      margin-left: 10px;
    }
  }
}
</style>
